import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  const [cartItems, setCartItems] = useState([]);

  const onAddToCart = (item) => {
  const exists = cartItems.find((i) => i.id === item.id && i.variant === item.variant);

    if (!exists) {
      setCartItems((prev) => [...prev, item]);
    }
  };

  return (
    <div>
      {/* You can add shared layout like header/footer here */}
      <Outlet context={{ cartItems, onAddToCart }} />
    </div>
  );
};

export default Layout;
